<template>
  <div id="home" v-loading="homeLoading">
    <el-container class="home-container">
      <my-slider @getTabindex="getTabindex" @getTabname="getTabname" ></my-slider>

      <el-container class="main">
        <my-header ref="add" :tabsName="tabsName" :tabsIndex="tabsIndex" :closeIndexTabs="closeIndexTabs" @tabsData="getIndexTabs" @collapseFn="handelCollapse"></my-header>

        <el-main class="main-body">
          <!--<router-view></router-view>-->
          <el-scrollbar style="height:100%" :class="hidelScr?'hidel-scroll':''">
            <!--按点击输出不同的组件-->
            <my-main ref="addc" :indexTabs="indexTabs" :indexTabsValue="indexTabsValue" :tabIndex="tabIndex" @hidelscroll="hidelscroll"></my-main>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import mySlider from "@/components/layout/slider.vue";
import myHeader from "@/components/layout/header.vue";
import myMain from "@/views/main.vue";

import index from "@/views/index.vue";

export default {
  data () {
    return {
      homeLoading: true,
      hidelScr: false,
      isCollapse: false,
      tabsName: "",
      tabsIndex: "",
      tabsArr: ["首页"],
      indexTabs: [
        {
          title: "首页",
          name: "1",
          content: index,
          close: false
        }
      ],
      indexTabsValue: "1",
      tabIndex: ""
    };
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        document.body.clientWidth < 1300
          ? (this.isCollapse = true)
          : (this.isCollapse = false);
      })();
    }
    document.body.clientWidth < 1300
      ? (this.isCollapse = true)
      : (this.isCollapse = false);
    window.addEventListener("beforeunload", e => this.beforeunloadHandler(e))
  },
  created () {
    document.body.clientWidth < 1460
      ? (this.isCollapse = true)
      : (this.isCollapse = false);
    //获取权限
    this.getAllRoles({});
    this.getPermission({});

    // console.log(JSON.parse(sessionStorage.getItem("headTabs")));
  },
  methods: {
    hidelscroll(v){
      this.hidelScr = v
    },
    handelCollapse (val) {
      this.isCollapse = val;
    },
    getTabindex (tab) {
      this.tabsIndex = tab;
    },
    getTabname (tab) {
      this.tabsName = tab;
    },
    getIndexTabs (data) {
      this.indexTabs = data.indexTabs;
      this.indexTabsValue = data.indexTabsValue;
    },
    closeIndexTabs (data) {
      this.indexTabs = data.indexTabs;
    },
    getAllRoles (params) {
      this.$axios
        .get("/api/v1/admin/getAllRoles", { params: params })
        .then(res => {
          if (res.data.status == 300) {
            sessionStorage.removeItem("login")
            setTimeout(() => {
              this.$router.push({
                path: "/login"
              });
            }, 2000);
            return false;
          }
          if (res.data.status == "200") {
            let roles = res.data.data.data;
            //传到store
            this.$store.dispatch("setRoles", roles);
            this.homeLoading = false;
          } else {
            this.$popup(res.data.msg, "error");
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    //获取用户所有按钮的权限
    getPermission (params) {
      this.$axios
        .get("/api/v1/admin/getPermissions", { params: params })
        .then(res => {
          if (res.data.status == "200") {
            let permission = res.data.data;
            let arr = [];
            //待优化
            for (let i in permission) {
              if (permission[i].children) {
                for (let j in permission[i].children) {
                  if (permission[i].children[j].children) {
                    for (let k in permission[i].children[j].children) {
                      arr.push(permission[i].children[j].children[k].api);
                    }
                  }
                }
              }
            }
            // console.log(arr);
            //传到store
            this.$store.dispatch("setPermission", permission);
            this.$store.dispatch("setRolesApi", arr);
          } else {
            this.$popup(res.data.msg, "error");
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    //获取权限的遍历多维数组方法
    // arrForEach (arr) {
    //   for (let i in arr) {
    //     if (arr[i].children) {
    //       this.arrForEach(arr[i].children)
    //       // for (let j in arr[i].children) {
    //       //   if (permission[i].children[j].children) {
    //       //     for (let k in permission[i].children[j].children) {
    //       //       arr.push(permission[i].children[j].children[k].api);
    //       //     }
    //       //   }
    //       // }
    //     }
    //   }
    // },
    //用户刷新缓存页面标签
    beforeunloadHandler (e) {
      sessionStorage.setItem(
        "headTabs",
        JSON.stringify(this.$store.state.headTabs)
      );
      sessionStorage.setItem(
        "currentHeadTab",
        JSON.stringify(this.$store.state.currentHeadTab)
      );
    }
  },
  components: {
    mySlider,
    myHeader,
    myMain
  }
};
</script>

<style lang="less">
@HEADER_HIGHT: 80px;
@HEADER_INNER: 40px;
#home > .el-loading-mask {
  z-index: 3001;
}
#home {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: "MicrosoftYaHei", "微软雅黑";
  .home-container {
    height: 100%;
    background-color: #f6f8fb;
    .main {
      display: flex;
      flex-flow: column;
      position: relative;
      top: 0;
      bottom: 0;
      width: 100%;
      // min-width: 1130px;
      height: 100%;
      background-color: #f6f8fb;
      .main-body {
        display: flex;
        flex-flow: column;
        position: absolute;
        top: @HEADER_HIGHT;
        width: 100%;
        height: calc(100% - @HEADER_HIGHT);
        padding: 0;
        overflow-x: hidden;
        background: inherit;
        .hidel-scroll {
          .el-scrollbar__bar {
            display: none;
          }
        }
        .el-scrollbar__wrap {
          padding: 0 20px;
          overflow-x: hidden;
        }
        .el-scrollbar__thumb {
          background-color: #c5c5c5;
        }
        .el-tabs__content{
          overflow: initial;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue